import { Injectable } from '@angular/core';
import { ApplicationRoles } from '../components/users/user-roles';
import { AuthModel, defaultAuthModelValues } from '../components/authorize/auth-model';
import { AccessControl, AccessControlDefaultValues } from '../components/users/access-control';
import { ApplicationLanguages } from '../components/language/language';
import { ADMIN_PROGRAM_MODE_KEY, AdminProgramMode } from '../components/authorize/admin-program-mode';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    constructor() { }
    timeZoneName:string='Pacific Standard Time'

    getAdminProgramMode(): AdminProgramMode {
        const stored = localStorage.getItem(ADMIN_PROGRAM_MODE_KEY);
        return stored === 'llttf' ? 'llttf' : 'bb';
    }

    setAdminProgramMode(mode: AdminProgramMode): void {
        localStorage.setItem(ADMIN_PROGRAM_MODE_KEY, mode);
    }

    /** True when the signed-in admin can access both BounceBack and LLTTF. */
    hasDualProgramAccess(): boolean {
        const access = this.getAccessControl();
        return (access.bbInvitaitons && access.llttfInvitations)
            || (access.canAddBBUsers && access.canAddLLTTFUsers);
    }

    /**
     * Effective program family for filters/UI:
     * - dual-access admins: stored BB/LLTTF mode
     * - LLTTF-only admins: llttf
     * - otherwise: bb
     */
    getEffectiveProgramMode(): AdminProgramMode {
        if (this.hasDualProgramAccess()) {
            return this.getAdminProgramMode();
        }
        const access = this.getAccessControl();
        if (access.llttfInvitations && !access.bbInvitaitons) {
            return 'llttf';
        }
        if (access.canAddLLTTFUsers && !access.canAddBBUsers) {
            return 'llttf';
        }
        return 'bb';
    }
    getAuthToken(): any {
        if (localStorage.getItem('token') == null) {
            return null;
        }
        return localStorage.getItem('token');
    }

    logout(): void {
        localStorage.clear();
    }

    checkTokenExpiry(): Boolean {
        const storeDate = localStorage.getItem('tokenExpiry');
        const tokenExpiry = storeDate ? new Date(storeDate) : new Date()
        const currentDate = new Date();
        const currentUtcTime = Date.UTC(
            currentDate.getUTCFullYear(),
            currentDate.getUTCMonth(),
            currentDate.getUTCDate(),
            currentDate.getUTCHours(),
            currentDate.getUTCMinutes(),
            currentDate.getUTCSeconds(),
            currentDate.getUTCMilliseconds()
        );
        if (tokenExpiry > new Date(currentUtcTime)) {
            return true;
        }
        else {
            this.logout();
            return false;
        }
    }

    getRole(): ApplicationRoles {
        const a = localStorage.getItem('role')
        const roleId: number | null = a !== null ? parseInt(a) : null;
        return roleId as ApplicationRoles
    }

    setUserLoginData(authmodel: AuthModel) {
        localStorage.setItem('username', authmodel.username);
        localStorage.setItem('token', authmodel.token);
        localStorage.setItem('tokenExpiry', authmodel.expiryUtc)
        localStorage.setItem('isParticipant', JSON.stringify(authmodel.isParticipant));
        localStorage.setItem('agentname', authmodel.agentName)
        localStorage.setItem('passwordchangerequireddays', authmodel.passwordChangeRequiredDays.toString())
        localStorage.setItem('userDbId', authmodel.userDbId.toString())
        localStorage.setItem('publicId', authmodel.publicId ?? '')
        localStorage.setItem('language',authmodel.participantLastActiveLanguage.toString())
        localStorage.setItem('showbblogo', JSON.stringify(authmodel.showBBLogo))
        localStorage.setItem('provinceId',authmodel.provinceId.toString())
    }

    getUserLoginData(): AuthModel {
        let userData = defaultAuthModelValues();
        userData.agentName = localStorage.getItem('agentname')!,
        userData.username = localStorage.getItem('username')!,
        userData.token = localStorage.getItem('token')!,
        userData.expiryUtc = localStorage.getItem('tokenExpiry')!
        userData.passwordChangeRequiredDays = parseInt(localStorage.getItem('passwordchangerequireddays')!)
        userData.userDbId = parseInt(localStorage.getItem('userDbId')!)
        userData.publicId = localStorage.getItem('publicId') ?? ''
        userData.isParticipant = JSON.parse(localStorage.getItem('isParticipant')!)
        userData.participantLastActiveLanguage = parseInt(localStorage.getItem('language')!) as ApplicationLanguages
        userData.showBBLogo = JSON.parse(localStorage.getItem('showbblogo')!)
        userData.provinceId = parseInt(localStorage.getItem('provinceId')!)
        return userData;
    }

    setAccessControl(accessControl:AccessControl)
    {
        localStorage.setItem('accessControl',JSON.stringify(accessControl));
    }

    getAccessControl():AccessControl
    {
        const stored = localStorage.getItem('accessControl');
        if (!stored) {
            return AccessControlDefaultValues();
        }
        return JSON.parse(stored);
    }
}